import React, { useEffect, useState, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI, deleteAPI, reinitialiseAPI } from 'store/apiReducer';
import {
    Bouton,
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    Row,
    Col,
    Container,
    GroupeBouton,
} from '@design-system-etat/dsfr-react';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import usagerClientReducer from '../../../../../../store/usagerReducer';
import {
    API_GET_REPRISE_DE_DONNEES_ARME,
    CONTEXT_GET_REPRISE_DE_DONNEES_ARME,
    API_DELETE_REPRISE_DE_DONNEES_ARME,
    CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME,
} from '../../../../../../constants/apiUrls.constants';
import BoutonsAction from './BoutonsAction';

const RepriseDeDonneesArme = ({
    getApi,
    deleteApi,
    reinitialiseApi,
    isLoadingRepriseDeDonneesArmes,
    dataRepriseDeDonneesArmes,
    isLoadingSupprimerRepriseDeDonneesArme,
    dataSupprimerRepriseDeDonneesArme,
}) => {
    const [modaleOuverte, setModaleOuverte] = useState(false);
    const [repriseDeDonneesUuid, setRepriseDeDonneesUuid] = useState(null);
    const handleClickAfficherModal = (repriseDeDonneesUuidSelectionne) => {
        setRepriseDeDonneesUuid(repriseDeDonneesUuidSelectionne);
        setModaleOuverte(true);
    };

    const fermerModale = () => {
        setModaleOuverte(false);
    };

    const supprimerRepriseDeDonneesArme = () => {
        reinitialiseApi(CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME);
        deleteApi(
            usagerClientReducer,
            `${API_DELETE_REPRISE_DE_DONNEES_ARME}/${repriseDeDonneesUuid}`,
            CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME,
        );
    };

    const apiGetRepriseDeDonnees = () => {
        reinitialiseApi(CONTEXT_GET_REPRISE_DE_DONNEES_ARME);
        getApi(
            usagerClientReducer,
            API_GET_REPRISE_DE_DONNEES_ARME,
            CONTEXT_GET_REPRISE_DE_DONNEES_ARME,
        );
    };

    useEffect(() => {
        apiGetRepriseDeDonnees();
    }, []);

    useEffect(() => {
        if (Array.isArray(dataRepriseDeDonneesArmes) && !isLoadingSupprimerRepriseDeDonneesArme) {
            fermerModale();
            apiGetRepriseDeDonnees();
        }
    }, [dataSupprimerRepriseDeDonneesArme]);

    const donnees = useMemo(() => {
        if (
            Array.isArray(dataRepriseDeDonneesArmes) &&
            dataRepriseDeDonneesArmes.length > 0 &&
            !isLoadingRepriseDeDonneesArmes
        ) {
            return dataRepriseDeDonneesArmes.map((data) => {
                return [
                    data.numeroRga,
                    data.numeroDeSerie,
                    data.type,
                    data.marque,
                    data.modele,
                    data.calibre1,
                    data.regimeDetention,
                    <BoutonsAction
                        handleClickAfficherModal={handleClickAfficherModal}
                        repriseDeDonneesUuid={data.uniquid}
                    />,
                ];
            });
        }

        return [];
    }, [isLoadingRepriseDeDonneesArmes]);

    const titres = [
        'Numéro RGA',
        'Numéro de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre Canon 1',
        'Régime de détention',
        'Action',
    ];

    if (
        !(
            Array.isArray(dataRepriseDeDonneesArmes) &&
            dataRepriseDeDonneesArmes.length > 0 &&
            !isLoadingRepriseDeDonneesArmes
        )
    ) {
        return <></>;
    }

    return (
        <Container margeExterne={false}>
            <Row>
                <Col col={12}>
                    <h4>
                        Armes nécessitant une mise à jour de votre part : complément/correction ou
                        suppression
                    </h4>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>
                        Deux boutons vous permettent soit de supprimer une arme, soit de corriger
                        les informations de l&apos;arme afin de l&apos;intégrer dans votre râtelier
                        définitif.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col col={3}>
                    <span className="fr-fi-edit-line" aria-hidden="true" /> Complément ou correction
                </Col>
                <Col col={3}>
                    <span className="fr-fi-delete-line" aria-hidden="true" /> Suppression
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <SimpleTable entete={titres} donnees={donnees} />
                </Col>
            </Row>

            {modaleOuverte && (
                <Modale taille="lg" closeCallback={fermerModale}>
                    <ModaleTitre>Suppression de l'arme</ModaleTitre>
                    <ModaleContent>
                        <Row>
                            <Col col={12}>
                                Si vous ne possédez pas cette arme pour l&apos;un des motifs
                                ci-dessous :
                            </Col>
                        </Row>
                        <Row>
                            <Col col={12}>
                                <ul>
                                    <li>Vous n&apos;avez jamais détenu cette arme</li>
                                    <li>Vous avez cédé cette arme</li>
                                    <li>
                                        Vous possédez déjà dans votre râtelier numérique une arme
                                        avec exactement les mêmes informations (doublon)
                                    </li>
                                </ul>
                                <br />
                                Vous pouvez la supprimer en cliquant sur le bouton
                                &quot;Supprimer&quot;.
                                <p>
                                    Dans le cas où vous supprimez une arme par erreur, vous pouvez
                                    l&apos;intégrer dans votre râtelier numérique via la procédure
                                    d&apos;&quot;Arme manquante&quot; en cliquant sur le bouton
                                    situé au dessus du tableau du râtelier numérique.
                                </p>
                            </Col>
                        </Row>
                    </ModaleContent>
                    <ModaleFooter>
                        <GroupeBouton alignementHorizontal="right" isHorizontal>
                            <Bouton
                                name="Annuler"
                                label="Annuler"
                                niveau="secondaire"
                                onClick={fermerModale}
                                disabled={isLoadingSupprimerRepriseDeDonneesArme}
                            />
                            <Bouton
                                name="Supprimer"
                                label="Supprimer"
                                niveau="primaire"
                                onClick={supprimerRepriseDeDonneesArme}
                                isLoading={isLoadingSupprimerRepriseDeDonneesArme}
                            />
                        </GroupeBouton>
                    </ModaleFooter>
                </Modale>
            )}
        </Container>
    );
};

RepriseDeDonneesArme.propTypes = {
    getApi: PropTypes.func.isRequired,
    deleteApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoadingRepriseDeDonneesArmes: PropTypes.bool,
    dataRepriseDeDonneesArmes: PropTypes.arrayOf(
        PropTypes.shape({
            uniquid: PropTypes.string,
            numeroRga: PropTypes.string,
            numeroDeSerie: PropTypes.string,
            type: PropTypes.string,
            marque: PropTypes.string,
            modele: PropTypes.string,
            calibre1: PropTypes.string,
            regimeDetention: PropTypes.string,
        }),
    ),
    isLoadingSupprimerRepriseDeDonneesArme: PropTypes.bool,
    dataSupprimerRepriseDeDonneesArme: PropTypes.string,
};

export default connect(
    (state) => {
        const { isLoading: isLoadingRepriseDeDonneesArmes, data: dataRepriseDeDonneesArmes } =
            state.repriseDeDonnees.recupererArmes;

        const {
            isLoading: isLoadingSupprimerRepriseDeDonneesArme,
            data: dataSupprimerRepriseDeDonneesArme,
        } = state.repriseDeDonnees.supprimerArme;

        return {
            isLoadingRepriseDeDonneesArmes,
            dataRepriseDeDonneesArmes,
            isLoadingSupprimerRepriseDeDonneesArme,
            dataSupprimerRepriseDeDonneesArme,
        };
    },
    {
        getApi: getAPI,
        deleteApi: deleteAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(RepriseDeDonneesArme);
